export default __webpack_public_path__ + "static/media/folder.d08810d1.svg";